import {lazyRegister} from "@core/lazyRegister";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {DistributorPriceListHistory} from "@/models";

export class ProductSizePricesService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetProductSizePrices(query: {}, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<any[]>('/api/ProductSizePrices', query, cancelToken);
    };

    GetProductPriceListHistory(query, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<DistributorPriceListHistory[]>('/api/ProductSizePrices/History', query, cancelToken);
    };

}


lazyRegister.service('ProductSizePricesService', ProductSizePricesService);